import {
  DragOutlined,
  DeleteOutlined,
  CopyOutlined,
  GroupOutlined,
} from "@ant-design/icons";
import { RefObject, SyntheticEvent } from "react";
import Node from "../tree/node";

interface ISelectedToolbar {
  draggingRef: RefObject<HTMLElement>;
  canDuplicate: boolean;
  canDelete: boolean;
  onDuplicate: (e: SyntheticEvent) => void;
  onDelete: (e: SyntheticEvent) => void;
  isSelectedNode: boolean;
  id: string;
  onSelectParentNode?: (e: SyntheticEvent) => void;
}

export const DragImg = new Image();
DragImg.src = "/components.png";
DragImg.style.width = "80px";
DragImg.style.height = "80px";
DragImg.style.position = "fixed";
DragImg.style.top = "-999px";
document.body.appendChild(DragImg);

export default ({
  draggingRef,
  canDuplicate,
  onSelectParentNode,
  onDuplicate,
  canDelete,
  onDelete,
  isSelectedNode,
  id,
}: ISelectedToolbar) => {
  return (
    <>
      <div
        style={{
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          left: 0,
          zIndex: 1,
          background: "#fc679a",
          marginTop: -16,
          marginLeft: -17,
          width: 32,
          height: 32,
          display: isSelectedNode ? "flex" : "none",
          fontSize: 22,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ color: "white" }} ref={draggingRef}>
          <DragOutlined style={{ width: 22, cursor: "pointer" }} />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: -35,
          right: 0,
          zIndex: 1,
          display: isSelectedNode ? "block" : "none",
        }}
      >
        <div
          style={{
            background: "#fc679a",
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 18,
            boxShadow: "0 0 10px #ccc",
            padding: 4,
          }}
        >
          {onSelectParentNode && (
            <span
              onClick={onSelectParentNode}
              data-id={id}
              title="Select row"
            >
              <GroupOutlined style={{ width: 22, cursor: "pointer" }} />
            </span>
          )}
          {canDuplicate && (
            <span onClick={onDuplicate} data-id={id} title="Duplicate">
              <CopyOutlined style={{ width: 22, cursor: "pointer" }} />
            </span>
          )}
          {canDelete && (
            <span onClick={onDelete} data-id={id} title="Delete">
              <DeleteOutlined style={{ width: 22, cursor: "pointer" }} />
            </span>
          )}
        </div>
      </div>
    </>
  );
};
